<template>
  <div class="app-menu-wrapper">
    <div class="app-logo">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <i-menu
            :active-name="activeMenu"
            theme="dark"
            width="auto"
            :class="menuitemClasses"
    >
      <MenuGroup title="">
        <menu-item name="administrator">
          <router-link :to="{ name: 'administrator' }">
            <Icon type="md-person" color="#FFFFFF" size="24" />
            <span>Administrator</span>
          </router-link>
        </menu-item>

        <menu-item name="databaseCleanup">
          <router-link :to="{ name: 'databaseCleanup' }">
            <Icon type="md-trash" color="#FFFFFF" size="24" />
            <span>Database Cleanup</span>
          </router-link>
        </menu-item>

        <menu-item name="serverLogs">
          <router-link :to="{ name: 'serverLogs' }">
            <Icon type="md-list-box" color="#FFFFFF" size="24" />
            <span>Server Logs</span>
          </router-link>
        </menu-item>

        <menu-item name="sessionTimeouts">
          <router-link :to="{ name: 'sessionTimeouts' }">
            <Icon type="ios-timer-outline" color="#FFFFFF" size="24" />
            <span>Session Timeouts</span>
          </router-link>
        </menu-item>

        <menu-item name="UILanguages">
          <router-link :to="{ name: 'UILanguages' }">
            <Icon type="md-globe" color="#FFFFFF" size="24" />
            <span>UI Languages</span>
          </router-link>
        </menu-item>
      </MenuGroup>
      <MenuGroup title="">
        <menu-item name="familyAccounts">
          <router-link :to="{ name: 'familyAccounts' }">
            <Icon type="ios-contacts" color="#FFFFFF" size="24" />
            <span>Family Accounts</span>
          </router-link>
        </menu-item>

        <menu-item name="games">
          <router-link :to="{ name: 'games' }">
            <Icon type="ios-game-controller-b" color="#FFFFFF" size="24" />
            <span>Games</span>
          </router-link>
        </menu-item>

        <menu-item name="mailTemplates">
          <router-link :to="{ name: 'mailTemplates' }">
            <Icon type="ios-mail" color="#FFFFFF" size="24" />
            <span>Message Templates</span>
          </router-link>
        </menu-item>
      </MenuGroup>
      <MenuGroup title="">

        <menu-item name="awardTrophy">
          <router-link :to="{ name: 'awardTrophy' }">
            <Icon type="ios-ribbon" color="#FFFFFF" size="24" />
            <span>Award Trophy</span>
          </router-link>
        </menu-item>

        <menu-item name="achievements">
          <router-link :to="{ name: 'achievements' }">
            <Icon type="ios-star" color="#FFFFFF" size="24" />
            <span>Achievements</span>
          </router-link>
        </menu-item>

        <menu-item name="medals">
          <router-link :to="{ name: 'medals' }">
            <Icon type="md-medal" color="#FFFFFF" size="24" />
            <span>Medals</span>
          </router-link>
        </menu-item>

        <menu-item name="tournaments">
          <router-link :to="{ name: 'tournaments' }">
            <Icon type="ios-flash" color="#FFFFFF" size="24" />
            <span>Tournaments</span>
          </router-link>
        </menu-item>

        <menu-item name="trophies">
          <router-link :to="{ name: 'trophies' }">
            <Icon type="md-trophy" color="#FFFFFF" size="24" />
            <span>Trophies</span>
          </router-link>
        </menu-item>

      </MenuGroup>
      <MenuGroup title="">
        <menu-item name="firmware">
          <router-link :to="{ name: 'firmware' }">
            <Icon type="ios-cog" color="#FFFFFF" size="24" />
            <span>Firmware</span>
          </router-link>
        </menu-item>
      </MenuGroup>

    </i-menu>
  </div>
</template>

<script>
  export default {
    props: {
      menuitemClasses: {
        default: "",
        type: String,
      }
    },
    data(){
      return{
        activeMenu:''
      }
    },
    created() {
      this.activeMenu = this.$route.name;
    },
  };
</script>

<style>
  .app-logo {
    text-align: center;
    padding: 15px;
    max-width: 220px;
    margin: 0 auto;
  }
  .app-logo img {
    width: 100%;
  }
  .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
    padding: 0!important;
  }
  .ivu-menu-item a {
    color: #ffffff;
    padding: 14px 24px;
    display: block;
  }
  .ivu-menu-item:hover a{
    color: #FFFFFF;
  }
  .menu-item span {
    display: inline-block;
    overflow: hidden;
    width: calc(100% - 38px);
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    transition: width 0.2s ease 0.2s;
    margin-left: 8px;
  }
  .menu-item i {
    transform: translateX(0px);
    transition: font-size 0.2s ease, transform 0.2s ease;
    vertical-align: middle;
    font-size: 16px;
  }
  .collapsed-menu span {
    display: none;
    margin-left: 0;
    transition: width 0.2s ease;
  }
  .collapsed-menu i {
    transform: translateX(5px);
    transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
    vertical-align: middle;
    font-size: 22px;
  }
</style>
